// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"331":"2ddbf0dc","674":"1fafdb7d"}[chunkId] + ".css";
};